<template>
  <div>
    <div class="row mb-5">
      <span class="display-4 col-12">
        {{ `${subscription.firstname} ${subscription.lastname}` }} -
        {{ $t("COMMON.LOGS") }}
      </span>
    </div>

    <log-list-table :filterSubject="subscription" />
  </div>
</template>
<script>
import LogListTable from "@/views/Pages/DefaultModule/LogManagement/partials/LogListTable.vue";

export default {
  name: "subscription-view-logs",

  components: { LogListTable },

  props: ["subscription"],

  mixins: [],

  data() {
    return {};
  },

  computed: {},

  methods: {},

  mounted() {},

  watch: {
    user(user) {},
  },
};
</script>
